import { InjectionToken } from '@angular/core';

export interface AnalyticWindow extends Window {
  dataLayer: string[];
}

export const ANALYTICS_WINDOW = new InjectionToken('ANALYTICS_WINDOW');
